import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import AddNewDistrict from '../add-new-district/AddNewDistrict';
import s from './Administrator.scss';

class Administrator extends React.Component {

  render() {
    return (
      <div className='header-container'>
        <header>
          <h1 className='header-text'>
            Panel administratora
          </h1>
        </header>
        <AddNewDistrict />
      </div>
    );
  }
}

export default withStyles(s)(Administrator);



// WEBPACK FOOTER //
// src/routes/administrator/components/administrator/Administrator.js